@if (isUser) {
  <wre-user-audit-table [list]="list" [isAddedorRemoved]="isAddedorRemoved"></wre-user-audit-table>
}
@if (!isUser) {
  <wre-permissions-audit-table
    [list]="list"
    [isAddedorRemoved]="isAddedorRemoved"></wre-permissions-audit-table>
}
